

















import {
  FiltrosProdutos,
  Produto,
  ProdutosService
} from "@/services/produtos.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { highlight } from "@/shared/filters";
import { Debounce } from "vue-debounce-decorator";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    Loading,
    Modal,
  }
})
export default class SelectProduto extends Vue {
  @Prop() value!: Produto;
  @Prop() idCatalogo!: string;
  @Prop() limiteDescricao!: number;
  @Prop() somenteAtivos!: boolean;
  @Prop() semKit!: boolean;

  loading = false;
  search = null;
  produtos = [] as Produto[];
  filters = {
    codigoFornecedor: "",
    ativos: true,
    sImagens: false,
  } as FiltrosProdutos;
  computed() {
    if (this.somenteAtivos) {
      this.filters.ativos = this.somenteAtivos;
    }
  }
  filtroDescricao(item: Produto, query: string, itemText: string) {
    const queries = query.toLocaleLowerCase().split(" ");
    let error = false;
    const textoBase = itemText ? itemText.toLocaleLowerCase() : "";
    const textoCompleto = `${item.codigoFornecedor} ${textoBase}`;
    queries.forEach((q) => {
      if (textoCompleto.indexOf(q) <= -1) {
        error = true;
        return;
      }
    });
    return !error;
  }

  @Debounce(500)
  @Watch("search")
  async onChange(val: string) {
    if (val) {
      this.loading = true;
      if (this.semKit) {
        this.produtos = await ProdutosService.listarProdutosDoCatalogoSemKit(
          this.idCatalogo,
          val
        );
      } else {
        this.filters.idCatalogo = this.idCatalogo;
        this.filters.descricao = val;
        this.produtos = await ProdutosService.listarProdutosDoCatalogo(
          this.filters
        );
      }

      this.loading = false;
    }
  }

  get model() {
    return this.value;
  }

  set model(val) {
    this.$emit("input", val);
  }

  highlight(value: string, term: string) {
    return highlight(value, term, 'v-list-item__mask');
  }
}
